<div class="row" [formGroup]="form">
    <div class="col-md-12">
        <h5>
            {{ 'Check-in information' | translate }}
        </h5>
        <p class="text-muted">
            {{ 'COMPANY_FORM_CHECKIN_INFO' | translate }}
        </p>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label>{{ 'Has info modal' | translate }}</label>
            <label class="switch d-block">
                <input type="checkbox" formControlName="hasSuccessModal">
                <span class="switch-state"></span>
            </label>
        </div>
    </div>
    <div *ngIf="isEnabled" class="col-md-6">
        <div class="form-group">
            <label>{{ 'Modal location' | translate }}</label>
            <select class="form-control" formControlName="successModalLocation">
                <option *ngFor="let option of availableLocations" [ngValue]="option.id">
                    {{ option.name | translate }}
                </option>
            </select>
        </div>
    </div>
    <div *ngIf="isEnabled" class="col-md-6">
        <div class="form-group">
            <label>{{ 'Button label' | translate }}</label>
            <input type="text" class="form-control" maxlength="255" placeholder="{{ 'Information' | translate }}"
                [ngModel]="title[selectedLanguage] || ''" (ngModelChange)="updateTitle($event)"
                [ngModelOptions]="{ standalone: true }">
        </div>
    </div>
    <div *ngIf="isEnabled" class="col-md-6">
        <div class="form-group">
            <label>{{ 'Content language' | translate }}</label>
            <div class="btn-group d-flex" role="group">
                <button *ngFor="let lang of languages" type="button" class="btn"
                    [class.btn-primary]="lang === selectedLanguage" [class.btn-light]="lang !== selectedLanguage"
                    (click)="selectedLanguage = lang">
                    {{ lang | uppercase }}
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="isEnabled" class="col-md-12">
        <div class="form-group">
            <label>{{ 'Modal content' | translate }}</label>
            <app-quill-editor [ngModel]="body[selectedLanguage] || ''" (ngModelChange)="updateBody($event)"
                [ngModelOptions]="{ standalone: true }" [imageUploadHandler]="uploadImage">
            </app-quill-editor>
            <small class="text-muted">{{ 'COMPANY_FORM_CHECKIN_LANGUAGE_INFO' | translate }}</small>
        </div>
    </div>
</div>
